;(function initializeImpactAttribution() {
  'use strict'

  if (window.LPImpactAttribution) return

  const COOKIE_NAME = 'im_ref'
  const COOKIE_MAX_AGE = 30 * 24 * 60 * 60
  const DOMAIN_SUFFIX = '.laserpecker.net'

  const currentUrl = parseUrl(window.location.href)
  const currentHostname = currentUrl?.hostname.toLowerCase() || ''
  const pendingLandingClickId = readLandingClickId(currentUrl)
  let activeClickId = pendingLandingClickId
  let privacyLoadRequested = false

  function parseUrl(value) {
    try {
      return new URL(value, window.location.href)
    } catch (_error) {
      return null
    }
  }

  function isLaserPeckerSubdomain(hostname) {
    return hostname.endsWith(DOMAIN_SUFFIX)
  }

  function readLandingClickId(url) {
    if (!url) return null

    const value = url.searchParams.get('im_ref')
    return typeof value === 'string' && value.length > 0 ? value : null
  }

  function readCookie() {
    try {
      const prefix = `${COOKIE_NAME}=`
      const cookie = document.cookie
        .split(';')
        .map((part) => part.trim())
        .find((part) => part.startsWith(prefix))

      if (!cookie) return null

      const value = decodeURIComponent(cookie.slice(prefix.length))
      return value.length > 0 ? value : null
    } catch (_error) {
      return null
    }
  }

  function writeCookie(clickId) {
    try {
      document.cookie = `${COOKIE_NAME}=${encodeURIComponent(clickId)}; Max-Age=${COOKIE_MAX_AGE}; Domain=.laserpecker.net; Path=/; Secure; SameSite=Lax`
    } catch (_error) {}
  }

  function deleteCookie() {
    try {
      document.cookie = `${COOKIE_NAME}=; Max-Age=0; Domain=.laserpecker.net; Path=/; Secure; SameSite=Lax`
    } catch (_error) {}
  }

  function applyMarketingPermission(isAllowed) {
    if (!isAllowed) {
      activeClickId = null
      deleteCookie()
      return
    }

    if (pendingLandingClickId) {
      activeClickId = pendingLandingClickId
      writeCookie(pendingLandingClickId)
      return
    }

    activeClickId = readCookie()
  }

  function syncMarketingPermission() {
    const customerPrivacy = window.Shopify?.customerPrivacy
    if (typeof customerPrivacy?.marketingAllowed !== 'function') return false

    try {
      applyMarketingPermission(customerPrivacy.marketingAllowed())
      return true
    } catch (_error) {
      return false
    }
  }

  function loadCustomerPrivacyApi() {
    if (syncMarketingPermission()) return
    if (privacyLoadRequested || typeof window.Shopify?.loadFeatures !== 'function') return

    privacyLoadRequested = true
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          privacyLoadRequested = false
          if (!error) syncMarketingPermission()
        },
      )
    } catch (_error) {
      privacyLoadRequested = false
    }
  }

  function decorateUrl(targetUrl) {
    if (!activeClickId || typeof targetUrl !== 'string' || targetUrl.length === 0) {
      return targetUrl
    }

    const destination = parseUrl(targetUrl)
    if (!destination || !['http:', 'https:'].includes(destination.protocol)) return targetUrl

    const destinationHostname = destination.hostname.toLowerCase()
    if (!isLaserPeckerSubdomain(currentHostname)) return targetUrl
    if (!isLaserPeckerSubdomain(destinationHostname)) return targetUrl
    if (destinationHostname === currentHostname) return targetUrl

    destination.searchParams.set('im_ref', activeClickId)
    return destination.toString()
  }

  function decorateClickedLink(event) {
    if (event.defaultPrevented || typeof event.target?.closest !== 'function') return

    const anchor = event.target.closest('a[href]')
    if (!anchor || typeof anchor.getAttribute !== 'function') return

    const targetUrl = anchor.getAttribute('href')
    const decoratedUrl = decorateUrl(targetUrl)
    if (decoratedUrl !== targetUrl && typeof anchor.setAttribute === 'function') {
      anchor.setAttribute('href', decoratedUrl)
    }
  }

  window.LPImpactAttribution = Object.freeze({ decorateUrl })

  document.addEventListener('click', decorateClickedLink, true)
  document.addEventListener('auxclick', decorateClickedLink, true)
  document.addEventListener('visitorConsentCollected', syncMarketingPermission)

  loadCustomerPrivacyApi()
  if (typeof window.addEventListener === 'function') {
    window.addEventListener('load', loadCustomerPrivacyApi, { once: true })
  }
})()
